
import Shimmer from "../ui/shimmer";

export const PaymentStatusLoading = () => (
  <div className="space-y-4 text-center">
    <div className="inline-flex items-center justify-center p-4 bg-primary/10 rounded-full mb-4">
      <Shimmer className="w-8 h-8 rounded-full" />
    </div>
    <Shimmer className="h-8 w-48 mx-auto" />
    <Shimmer className="h-12 w-32 mx-auto" />
    <Shimmer className="h-4 w-56 mx-auto" />
  </div>
);

export const PaymentSummaryLoading = () => (
  <div className="bg-card/10 backdrop-blur-lg border-border/10 p-6 space-y-4 rounded-xl">
    <Shimmer className="h-6 w-40" />
    <div className="space-y-2">
      <div className="flex justify-between">
        <Shimmer className="h-4 w-32" />
        <Shimmer className="h-4 w-16" />
      </div>
      <div className="flex justify-between">
        <Shimmer className="h-4 w-24" />
        <Shimmer className="h-4 w-16" />
      </div>
      <div className="h-px bg-border/10 my-2" />
      <div className="flex justify-between">
        <Shimmer className="h-4 w-16" />
        <Shimmer className="h-4 w-20" />
      </div>
    </div>
  </div>
);

export const PaymentHistoryLoading = () => (
  <div className="bg-card/10 backdrop-blur-lg rounded-xl p-6 border border-border/10">
    <Shimmer className="h-6 w-48 mb-6" />
    <div className="space-y-4">
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className="flex justify-between items-center p-4 bg-card/20 rounded-lg border border-border/10"
        >
          <div className="space-y-2">
            <Shimmer className="h-5 w-32" />
            <Shimmer className="h-4 w-40" />
          </div>
          <div className="text-right space-y-2">
            <Shimmer className="h-5 w-20" />
            <Shimmer className="h-4 w-24" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export const LoadingState = () => (
  <div className="min-h-screen bg-background text-primary pb-24">
    <div className="container mx-auto px-4 py-8">
      <div className="space-y-8 animate-fade-in">
        <header className="p-4 pt-16 sm:p-6 sm:pt-12 space-y-2 sm:space-y-4 text-center">
          <Shimmer className="h-8 w-48 mx-auto" />
          <Shimmer className="h-4 w-64 mx-auto" />
        </header>
        
        <div className="p-8 bg-primary/10 space-y-6">
          <PaymentStatusLoading />
        </div>
        
        <PaymentHistoryLoading />
      </div>
    </div>
    
    {/* Loading spinner for transitions */}
    <div className="fixed inset-0 pointer-events-none flex items-center justify-center z-50 opacity-0 transition-opacity duration-300" id="loading-spinner">
      <div className="w-12 h-12 border-4 border-t-primary rounded-full animate-spin
        dark:border-t-white 
        ocean:border-t-ocean-DEFAULT 
        sunset:border-t-sunset-DEFAULT 
        forest:border-t-forest-DEFAULT"></div>
    </div>
  </div>
);
